import { render, staticRenderFns } from "./ShiftOverview.vue?vue&type=template&id=5bb27743&scoped=true"
import script from "./ShiftOverview.vue?vue&type=script&lang=ts"
export * from "./ShiftOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb27743",
  null
  
)

export default component.exports